import { 
    ProviderUsageResult,
    AmountUsage,
    Usage,
    Model,
    RequestInformation
} from '@/lib/types'
import { getGenerationStats } from '../request/query-open-router-cost'
import { ModelId } from '../models'
import { PricingCore } from '@/lib/pricing/pricing-core'







export async function calculateOpenrouterUsage({
    responseAPI,
    model,
}: {
    responseAPI: RequestInformation['responseAPI']
    model: Model
}): Promise<ProviderUsageResult> {
    const generationId = responseAPI.response.id

    const generationStats = await getGenerationStats(generationId)
    const data = generationStats.data

    const providerUsage: ProviderUsageResult['providerUsage'] = {
        inputTokens: data.tokens_prompt || undefined,
        completionTokens: data.tokens_completion || undefined,
        reasoningTokens: data.native_tokens_reasoning || undefined,
        outputTokens: (data.tokens_completion && data.native_tokens_reasoning) 
            ? (data.tokens_completion + data.native_tokens_reasoning)
            : (data.tokens_completion || data.native_tokens_reasoning || undefined),
        inputImages: data.num_media_prompt || undefined,
        outputImages: data.num_media_completion || undefined,
    }


    const calulcatedAmountUsage = calculateAmountUsage({
        inputTokens: data.tokens_prompt || 0,
        outputTokens: data.tokens_completion || 0,
        totalCost: data.total_cost || 0,
        model,
    })


    const metadata = { 
        calculatedInputAmount: calulcatedAmountUsage.calculatedInputAmount,
        calculatedOutputAmount: calulcatedAmountUsage.calculatedOutputAmount,
        calculatedTotalAmount: calulcatedAmountUsage.calculatedTotalAmount,
        modelPricing: model.pricing,
        openRouterGenerationStats: data,
    }


    const amountUsage: AmountUsage = {
        inputAmount: null,
        outputAmount: null,
        totalAmount: data.total_cost,
        profitMultiplier: PricingCore.getProfitMultiplier(model),
    }


    return {
        amountUsage,
        providerUsage,
        metadata,
    }
}





function calculateAmountUsage({
    inputTokens,
    outputTokens,
    model,
    totalCost,
}: {
    inputTokens: number
    outputTokens: number
    model: Model
    totalCost: number
}) {
    const calculatedInputAmount = model.pricing.input_token ? inputTokens * model.pricing.input_token : 0
    const calculatedOutputAmount = model.pricing.output_token ? outputTokens * model.pricing.output_token : 0   
    
    return {
        calculatedInputAmount,
        calculatedOutputAmount,
        calculatedTotalAmount: calculatedInputAmount + calculatedOutputAmount,
    }
}